import { CommonModule } from '@angular/common'
import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { DynamicTextComponent } from '../dynamic-text/dynamic-text.component'
import { ChannelNameWidget } from 'htv-lib'
import { Subscription } from 'rxjs'
import { LocalChannel } from '../../interfaces/local-channel'
import { PageService } from '../../services/page.service'
import { PAGE_KEY } from '../../constants/page.constants'

@Component({
  selector: 'app-channel-name',
  standalone: true,
  imports: [CommonModule, DynamicTextComponent],
  templateUrl: './channel-name.component.html',
  styleUrls: [],
})
export class ChannelNameComponent implements OnInit, OnDestroy {
  subscriptions = new Subscription()
  @Input() config!: ChannelNameWidget

  text = ''

  constructor(private pageService: PageService) {
    // do nothing
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.pageService.getSubject(PAGE_KEY.SELECTED_CHANNEL)?.subscribe((channel: LocalChannel | undefined) => {
        if (channel) {
          this.text = channel.name
        } else {
          this.text = ''
        }
      })
    )
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe()
  }
}
